module.exports = __webpack_public_path__ + "static/img/zanting2.9499306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zanting2.png
// module id = V1Ul
// module chunks = 24